export default function Footer() {
  return (
    <footer className="bg-[#0f0f0f] border-t border-[#111] px-4 py-5">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-[#333] text-xs flex items-center gap-1.5">
          <i className="ri-heart-fill text-[#ef4444]" />
          Built with a love for God&apos;s Word.
        </p>
        <p className="text-[#333] text-xs">AppleSMP Bible &middot; The Word, Always Within Reach</p>
      </div>
    </footer>
  );
}
